import { CONNECTION_TYPE } from "../enum/connection.enum";
import { ENUM_SCORES } from "../enum/contracts.enum";
import AppIcx from "@ledgerhq/hw-app-icx";

const IconService = require("icon-sdk-js").default;

const {
  IconBuilder,
  HttpProvider,
  IconAmount,
  IconConverter,
  IconValidator,
  IconUtil,
} = IconService;

const { CallBuilder } = IconBuilder;

const httpProvider =
  process.env.REACT_APP_NETWORK === "testnet"
    ? new HttpProvider(CONNECTION_TYPE.URL.TESTNET_SEJONG)
    : new HttpProvider(CONNECTION_TYPE.URL.MAINNET);

const nid =
  process.env.REACT_APP_NETWORK === "testnet"
    ? new HttpProvider(CONNECTION_TYPE.NETWORK_ID.TESTNET_SEJONG)
    : new HttpProvider(CONNECTION_TYPE.NETWORK_ID.MAINNET);

const iconService = new IconService(httpProvider);
const callBuilder = new CallBuilder();

const signTransaction = async (
  transaction: any,
  walletPath: any,
  transport: any
) => {
  const rawTransaction = IconConverter.toRawTransaction(transaction);
  const hashKey = IconUtil.generateHashKey(rawTransaction);
  const icx = new AppIcx(transport);
  // @ts-ignore
  const { signedRawTxBase64 } = await icx.signTransaction(walletPath, hashKey);
  rawTransaction.signature = signedRawTxBase64;
  return {
    getProperties: () => rawTransaction,
    getSignature: () => signedRawTxBase64,
  };
};

export const handleLoginViaICONex = () => {
  window.dispatchEvent(
    new CustomEvent("ICONEX_RELAY_REQUEST", {
      detail: {
        type: "REQUEST_ADDRESS",
      },
    })
  );
};

export const SCOREMethodGetCall = async (
  method: string,
  contract: string | undefined,
  params?: any
) => {
  try {
    const call = callBuilder
      .to(contract)
      .method(method)
      .params(params || {})
      .build();
    const result = await iconService.call(call).execute();
    return result;
  } catch (e) {
    throw e;
  }
};

export const SCOREMethodSetCall = async (
  address: string,
  method: string,
  contract: string | undefined,
  params: any,
  isLedger?: boolean | undefined,
  ledgerPath?: any,
  ledgerTransport?: any,
  stepLimit?: number
) => {
  try {
    console.log("These are params", address, method, contract, params);

    const callTransactionBuilder = new IconBuilder.CallTransactionBuilder();
    const txObj = callTransactionBuilder
      .from(address)
      .to(contract)
      .stepLimit(IconConverter.toBigNumber(stepLimit?.toString() || "5000000"))
      .nid(IconConverter.toBigNumber(nid.url))
      .nonce(IconConverter.toBigNumber("1"))
      .version(IconConverter.toBigNumber("3"))
      .timestamp(new Date().getTime() * 1000)
      .method(method)
      .params(params)
      .build();

    if (isLedger) {
      console.log("This is ledger!!");
      const signedTransaction = await signTransaction(
        txObj,
        ledgerPath,
        ledgerTransport
      );

      console.log("signed tx", signedTransaction);
      const res = await iconService
        .sendTransaction(signedTransaction)
        .execute();

      console.log("res", res);

      return res;
    } else {
      type scoreDataType = {
        value?: string;
      };

      let scoreData: scoreDataType = {};
      scoreData.value = JSON.stringify({
        jsonrpc: "2.0",
        method: "icx_sendTransaction",
        params: IconConverter.toRawTransaction(txObj),
        id: 50889,
      });

      const parsed = JSON.parse(scoreData.value);

      window.dispatchEvent(
        new CustomEvent("ICONEX_RELAY_REQUEST", {
          detail: {
            type: "REQUEST_JSON-RPC",
            payload: parsed,
          },
        })
      );
    }
  } catch (e) {
    throw e;
  }
};

export const getTransactionResult = async (tx: any) => {
  try {
    const transactionResult = await iconService
      .getTransactionResult(tx)
      .execute();
    return {
      status: transactionResult.status === 1 ? "success" : "error",
      msg:
        transactionResult.status === 1
          ? "Success"
          : transactionResult.failure.message,
      tx: tx,
      eventLogs:
        transactionResult.status === 1
          ? transactionResult.eventLogs
          : "no_logs",
    };
  } catch (e) {
    if (
      // @ts-ignore
      e.includes("Pending") ||
      // @ts-ignore
      e.includes("Executing") ||
      e === "[RPC ERROR] Invalid params txHash"
    ) {
      return {
        status: "pending",
        msg: "Pending Transaction",
        tx: tx,
      };
    }

    return {
      status: "error",
      msg: "Invalid Transaction",
      tx: tx,
    };
  }
};

export const objectToHexWithPrefix = (params: any) => {
  const enc = new TextEncoder();
  const arrayBuffer = enc.encode(JSON.stringify(params));

  if (
    typeof arrayBuffer !== "object" ||
    arrayBuffer === null ||
    typeof arrayBuffer.byteLength !== "number"
  ) {
    throw new TypeError("Expected input to be an ArrayBuffer");
  }

  const view = new Uint8Array(arrayBuffer);
  let result = "";
  let value;

  for (let i = 0; i < view.length; i += 1) {
    value = view[i].toString(16);
    result += value.length === 1 ? `0${value}` : value;
  }

  return `0x${result}`;
};
